import React, { FC } from "react";
import classNames from "classnames";
import styles from "./CarouselControls.module.css";
import { ChevronLeft, ChevronRight } from "../../icons";

export type CarouselControlsProps = {
  count: number;
  activeIndex: number;
  onDotClick: (index: number) => void;
  onPrev?: () => void;
  onNext?: () => void;
  prevDisabled?: boolean;
  nextDisabled?: boolean;
  className?: string;
};

export const CarouselControls: FC<CarouselControlsProps> = ({
  count,
  activeIndex,
  onDotClick,
  onPrev,
  onNext,
  prevDisabled = false,
  nextDisabled = false,
  className,
}) => (
  <div className={classNames(styles.row, className)}>
    <div className={styles.dots}>
      {Array.from({ length: count }, (_, index) => (
        <button
          key={index}
          className={classNames(
            styles.dot,
            index === activeIndex && styles.dotActive
          )}
          aria-label={`Go to slide ${index + 1}`}
          onClick={() => onDotClick(index)}
        />
      ))}
    </div>
    {(onPrev || onNext) && (
      <div className={styles.arrows}>
        <button
          type="button"
          className={styles.arrow}
          aria-label="Previous slide"
          onClick={onPrev}
          disabled={!onPrev || prevDisabled}
        >
          <ChevronLeft size={24} />
        </button>
        <button
          type="button"
          className={styles.arrow}
          aria-label="Next slide"
          onClick={onNext}
          disabled={!onNext || nextDisabled}
        >
          <ChevronRight size={24} />
        </button>
      </div>
    )}
  </div>
);
